import SectionDescription from './SectionDescription.js';

export default SectionDescription;
